import { onGetAbsentStudent, onGetAbsentStudentByGrade } from 'data/absent/absent.service';
import { useDispatch } from 'react-redux';
import absentSlice from 'redux/slice/absent.slice';
import absentByGradeSlice from 'redux/slice/absentByGrade.slice';

export const useDashboard = () => {
  const dispatch = useDispatch();

  const fetchAbsentStudents = async () => {
    dispatch(absentSlice.actions.setLoading());
    try {
      const res = await onGetAbsentStudent();
      dispatch(absentSlice.actions.setData(res));
    } catch (err) {
      dispatch(absentSlice.actions.setError(err));
    }
  };

  const fetchAbsentStudentsByGrade = async (grade: string, section: string) => {
    dispatch(absentByGradeSlice.actions.setLoading());
    try {
      const res = await onGetAbsentStudentByGrade(grade, section);
      dispatch(absentByGradeSlice.actions.setData(res));
    } catch (err) {
      dispatch(absentByGradeSlice.actions.setError(err));
    }
  };

  return {
    fetchAbsentStudents,
    fetchAbsentStudentsByGrade,
  };
};
